import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export enum UserType {
    consumer = 0,
    office365 = 1,
}

export function getUserTypeString(): string {
    const userType = getUserType();
    return getTypeStringFromType(userType);
}

function getUserType(): UserType {
    if (isConsumer()) {
        return UserType.consumer;
    }
    return UserType.office365;
}

function getTypeStringFromType(type: UserType): string {
    if (type === UserType.consumer) {
        return 'outlookCom';
    }
    return 'office365';
}
